
<template>
  <div class="w w1200">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="aside">
          <h4 class="aside-title">商家入驻指南</h4>
          <ul class="aside-list">
            <li class="aside-item">签订入驻协议</li>
            <li class="aside-item">填写商家资料</li>
            <li class="aside-item active">平台审核</li>
            <li class="aside-item">合同签订及缴费</li>
            <li class="aside-item">店铺开通</li>
          </ul>
        </div>
        <div class="aside">
          <h4 class="aside-title">平台联系方式</h4>
          <ul class="aside-list">
            <li class="aside-item">电话：400-0456880</li>
            <li class="aside-item">邮箱：18748424242@163.com</li>
          </ul>
        </div>
      </el-col>
      <el-col :span="18" class="rightaside" v-if="storeData">
        <el-card header="店铺状态" shadow="never">
          <div class="state-wrapper">
            <template v-if="storeData.merchantStatus === 'WAIT_AUDIT'">
              <!--    等待审核    -->
              <i class="state-icon el-icon-alarm-clock"></i>
              <div>您的申请已提交</div>
              <div>请耐心等待平台审核</div>
            </template>
            <template v-if="storeData.merchantStatus === 'WAIT_PAY'">
              <!--    等待付款    -->
              <i class="state-icon el-icon-circle-check"></i>
              <div>资料审核已通过，等待缴费</div>
              <el-button type="primary" @click="$router.push('/settleIn/merchantPayFor')">上传支付凭证</el-button>
            </template>
            <template v-if="storeData.merchantStatus === 'PAY_AUDIT'">
              <!--    缴费待审核     -->
              <i class="state-icon el-icon-money"></i>
              <div>已缴费</div>
              <div>缴费凭证已上传,审核中</div>
            </template>
            <template v-if="storeData.merchantStatus === 'PAID'">
              <!--    已缴费，申请完成    -->
              <i class="state-icon el-icon-s-goods"></i>
              <div>恭喜您！</div>
              <div>您的店铺已开通！</div>
            </template>
            <template v-if="storeData.merchantStatus === 'AUDIT_ERROR'">
              <!--    审核失败    -->
              <i class="state-icon el-icon-circle-close"></i>
              <div>您的申请未通过</div>
              <div class="reason">原因:{{ storeData.auditMemo }}</div>
              <div class="btn-box">
                <el-button type="primary" @click="applyRedo">重新申请</el-button>
              </div>
            </template>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    storeData () {
      return this.$store.state.applyStoreData;
    }
  },
  methods: {
    applyRedo () {
      this.$router.replace('/settleIn/merchantForm?type=edit');
    }
  }
};
</script>

<style scoped lang="less">
.btn-box{
  margin-top: 15px;
}
.jy_bg_css{
    height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.breakcrumbHeader {
  margin: 15px 0;
}
.aside {
  box-sizing: border-box;
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 40px;
  background-color: #fff;

  .aside-title {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    font-weight: 700;
  }

  .aside-item {
    padding: 10px;

    &.active {
      color: var(--main-theme-color);
    }
  }
}
/deep/ .el-card__header{
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 500;
}
.state-wrapper{
  text-align: center;
  padding: 20px 0;
  font-size: 18px;
  .state-icon{
    font-size: 8em;
    color: #ffbc65;
    margin-bottom: 20px;
    &.el-icon-circle-close{
      color: var(--main-theme-color);
    }
    &.el-icon-s-goods,
    &.el-icon-circle-check{
      color: #65f387;
    }
  }
  .reason{
    display: inline-block;
    width: 300px;
    padding: 10px;
    color: var(--main-theme-color);
    font-size: 14px;
    margin: 10px 0;
    border: 1px solid #f0a2a2;
    border-radius: 10px;
    background-color: #ff5f5714;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/merchantSettled/merchantStatus.vue